<div class="modal-header">
    <h3 class="modal-title text-modal-header-bold" id="modal-basic-title"> Búsqueda de proveedores</h3>
    <button type="button" class="close" aria-label="Close" (click)="cancelar()"
    tabindex="205">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-sm row-border hover nowrap">
                    <thead>
                        <tr>
                            <th> Código </th>
                            <th> Descripción </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="cursor" [ngClass]="{'color-row': position == i}"
                            *ngFor="let lst of proveedores; index as i" (click)="onClick(lst)">
                            <td>{{lst.codpro}}</td>
                            <td style="text-align: left;">{{lst.razonc}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>